import ProjectPropertyLookup, {SourceType} from "./project-property-lookup";
import ProjectSession from "../project-session"

export default class CRMAccountLookup extends ProjectPropertyLookup {

    constructor(projectId:ID) {
        super(projectId)
    }

    get(): ID | undefined {
        let res

        // 1. check if project has property and retrieve crm account id
        if (!!this.project?.crmAccountId) {
            res = this.project.crmAccountId
            this.sourceType = SourceType.CUSTOM
        }

        // 2. if crm account id not found yet check parents
        if (!res) {
            const getParentCrmAccountId = (project?: ProjectSession) => {
                if (project) {
                    if (project.treeParent?.crmAccountId) {
                        res = project.treeParent.crmAccountId
                        this.sourceType = SourceType.INHERITED
                        this.sourceProjectId = project.treeParent.id
                    } else {
                        getParentCrmAccountId(project.treeParent)
                    }
                }
            }

            getParentCrmAccountId(this.project)
        }

        return res
    }
}